/**
 * When an author tags a run like "$24M YoY" as a model quantity, the
 * mark→node conversion replaces the whole run with a value-only atom node.
 * To preserve the trailing label ("YoY", "YtD", "patients", …) we split it
 * off here and store it as the node's `suffix` attribute.
 *
 * Heuristic: consume the leading value portion — optional sign, optional
 * currency symbol, a number (with thousands/decimal separators), and an
 * optional unit (%, or a K/M/B/T magnitude letter) — then treat whatever
 * remains as the suffix. Returns null when there's no trailing text.
 *
 * Dependency-free so it can be unit-tested without the tiptap editor.
 */
const VALUE_PREFIX = /^\s*[-+]?\s*[$€£¥]?\s*\d[\d.,]*\s*(?:%|[KMBT])?/i;

export function extractValueSuffix(text: unknown): string | null {
    if (typeof text !== "string") return null;
    const match = text.match(VALUE_PREFIX);
    // No leading value at all — don't guess; keep nothing as a "suffix".
    if (!match) return null;
    const rest = text.slice(match[0].length).trim();
    return rest.length ? rest : null;
}
